import type { AppConfig } from "@src/im/types/config";

export const mainModel = {
    /** 当前加载的应用配置 */
    appConfig: undefined as AppConfig | undefined,
}